import { render, staticRenderFns } from "./AttendeeSelector.vue?vue&type=template&id=36631c4a&"
import script from "./AttendeeSelectorVue.ts?vue&type=script&lang=ts&"
export * from "./AttendeeSelectorVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports